import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { useCopy } from '@/hooks/use-copy'
import { useOrganizationStore } from '@/store/organization'
import { CheckIcon, CopyIcon } from 'lucide-react'

export const Settings = () => {
  return (
    <div className="px-4 py-8 mx-auto max-w-7xl sm:px-6 lg:px-8">
      <div className="mb-8 sm:flex sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold text-foreground">Settings</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            Manage your account settings
          </p>
        </div>
      </div>

      <div className="space-y-6">
        <AccountIdCard />
      </div>
    </div>
  )
}

const AccountIdCard = () => {
  const accountId = useOrganizationStore((s) => s.organization?.account_id)
  const { copy, copied } = useCopy()

  return (
    <Card>
      <CardHeader className="border-b">
        <CardTitle>Account ID</CardTitle>
      </CardHeader>
      <CardContent className="p-6">
        <div className="flex justify-between items-center">
          <div className="space-y-1">
            <p className="text-sm text-muted-foreground">
              This is the account ID used for API calls
            </p>
            <p className="font-medium">
              {accountId || 'No account ID available'}
            </p>
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={() => accountId && copy(accountId)}
            disabled={!accountId}
          >
            {copied ? (
              <>
                <CheckIcon className="mr-2 w-4 h-4" />
                Copied
              </>
            ) : (
              <>
                <CopyIcon className="mr-2 w-4 h-4" />
                Copy
              </>
            )}
          </Button>
        </div>
      </CardContent>
    </Card>
  )
}
